import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as JotaiProvider } from 'jotai';
import { BrowserRouter } from 'react-router-dom';
import LocalizedApp from './LocalizedApp';

// eslint-disable-next-line no-undef
if (ENV !== 'dev') {
  if ('serviceWorker' in navigator) {
    console.log('serviceWorker registering');
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <JotaiProvider>
      <LocalizedApp />
    </JotaiProvider>
  </BrowserRouter>
);
